module.exports = __webpack_public_path__ + "img/icon_cart.db875903.png";